import { ALLOWED_EXTENSIONS } from '../constants';

export const isAllowedExtensionByUrl = (fileUrl: string): boolean => {
    // If the url doesn't have a dot, return true
    if (!fileUrl.includes('.')) {
        return true;
    }

    // Remove query parameters first
    const urlWithoutQuery = fileUrl.split('?')[0];

    // Extract the filename from the URL path (everything after the last slash)
    const filename = urlWithoutQuery.split('/').pop() ?? '';

    // If there's no filename or it doesn't have a dot, return true
    if (!filename || !filename.includes('.')) {
        return true;
    }

    // Get the extension from the filename (everything after the last dot)
    const extension = filename.split('.').pop()?.toLowerCase() ?? '';

    return ALLOWED_EXTENSIONS.includes(extension);
};
